// project imports

// action - state management
import * as actionTypes from '../actions';

export const initialState = {
    // isOpen: [], // for active default menu
    // defaultId: 'default',
    // opened: true,
    isLoad: false,
    authToken: localStorage.getItem("lawgeekToken"),
};

// ==============================|| CUSTOMIZATION REDUCER ||============================== //

const CommonReducer = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.SETLOADER:
            return {
                ...state,
                isLoad: action.payload
            };
        case actionTypes.GETAUTHTOKEN:
            return {
                ...state,
                authToken: initialState.authToken
            };
        case actionTypes.SETAUTHTOKEN:
            return {
                ...state,
                authToken: action.payload
            };
        case actionTypes.SETAUTHUSER:
            return {
                ...state,
                authUser: action.payload
            };


        default:
            return state;
    }
};

export default CommonReducer;
